import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { SEO } from '../components/common';
import { Button } from '../components/ui';

/**
 * 404 Not Found page component
 */
const NotFoundPage = () => {
  return (
    <>
      <SEO title="Page Not Found" />
      
      <section className="min-h-[70vh] flex items-center py-16">
        <div className="container-custom">
          <div className="max-w-lg mx-auto text-center">
            {/* 404 Illustration */}
            <div className="relative mb-8">
              <div className="text-[150px] md:text-[200px] font-bold text-primary-100 leading-none select-none">
                404
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-24 h-24 bg-primary-100 rounded-full flex items-center justify-center">
                  <span className="text-4xl">🔍</span>
                </div>
              </div>
            </div>

            <h1 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-4">
              Page Not Found
            </h1>
            <p className="text-neutral-600 mb-8 leading-relaxed">
              Oops! The page you&apos;re looking for doesn&apos;t exist or has been moved. 
              Don&apos;t worry, let&apos;s get you back on track.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/">
                <Button variant="primary" icon={Home}>
                  Go to Homepage
                </Button>
              </Link>
              <button onClick={() => window.history.back()}>
                <Button variant="outline" icon={ArrowLeft}>
                  Go Back
                </Button>
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFoundPage;
